import styles from './PricingTableRowTitle.module.scss';

import React, { useState } from 'react';

import {
  LinkVariant,
  PricingTableFeatureType,
  ContentImageEntry,
  Link,
  ProductModule,
} from 'api/contentful/contentTypes.cloverdotcom';
import { Button } from 'components/Button/Button';
import { ContentImage } from 'components/ContentImage/ContentImage';
import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { ProductModal } from 'components/ProductModal/ProductModal';
import { TextV2 } from 'components/TextV2/TextV2';
import type { BundleFeature } from 'services/cms/bundleTypes';
import type { FlatEntry } from 'services/cms/flattenContentful';
import { PRICING_TABLE_ROW_TITLE_TEST_ID } from './PricingTableRowTitle.const';

type PricingTableRowTitleProps = BundleFeature &
  React.HTMLAttributes<HTMLTableCellElement> & {
    categoryId?: string;
    featureId?: string;
    productDetails?: FlatEntry<ProductModule>;
    variant?: string;
    link?: FlatEntry<Link>;
  };

const renderCellBody = (image?: ContentImageEntry, title?: string, description?: string): React.ReactNode => (
  <>
    {image && <ContentImage entry={image} className={styles.titleColumnIcon} alt="" />}

    <span className={styles.titleColumnText}>
      {title && (
        <TextV2 value={title} variant="body-small" data-testid={PRICING_TABLE_ROW_TITLE_TEST_ID.title} />
      )}
      {description && (
        <TextV2
          isMarkdown
          value={description}
          tagName="small"
          variant="body-small"
          data-testid={PRICING_TABLE_ROW_TITLE_TEST_ID.description}
        />
      )}
    </span>
  </>
);

export const PricingTableRowTitle: React.FC<PricingTableRowTitleProps> = ({
  title,
  description,
  image,
  categoryId,
  featureId,
  productDetails,
  variant,
  link,
  ...props
}) => {
  const [modalState, toggleModal] = useState(false);

  return (
    <th
      className={styles.tableCell}
      scope="row"
      {...props}
      headers={`category-${categoryId}`}
      id={`feature-${featureId}`}
    >
      <div className={styles.titleColumn}>
        {productDetails && variant === PricingTableFeatureType.PRODUCT_MODAL && (
          <>
            <Button
              variant={LinkVariant.TEXT}
              onClick={productDetails ? () => toggleModal(true) : undefined}
              className={styles.titleColumnButton}
              isFullWidth
            >
              {renderCellBody(image, title, description)}
            </Button>
            <ProductModal
              closeModal={() => toggleModal(bool => !bool)}
              modalOpen={modalState}
              productDetails={productDetails}
            />
          </>
        )}
        {link && variant === PricingTableFeatureType.LINK && (
          <ContentLinkV2 entry={link} hideTitle className={styles.titleColumnButton}>
            {renderCellBody(image, title, description)}
          </ContentLinkV2>
        )}
        {!variant && renderCellBody(image, title, description)}
      </div>
    </th>
  );
};
